import React from 'react';
import { BsArchiveFill } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, Flex, Icon, IconButton } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../../../../../../../../constants/analyticsIds';
import { showModal } from '../../../../../../../../../../redux/modules/modal';
import ArchivedAttachmentsModal from '../ArchivedAttachmentsModal';

const AttachmentIconTray = ({ recordId }) => {
  const dispatch = useDispatch();

  return (
    <Box fontSize={18} m={0} zIndex={5}>
      <Flex>
        <IconButton
          aria-label="archived-attachments-modal-icon"
          data-analytics-id={analyticsIds.insuredProfilePage.attachmentsComponent.openArchivedAttachmentsModal}
          dusk="open-archived-attachments-modal-button"
          icon={<Icon as={BsArchiveFill} boxSize="20px" />}
          variant="textWhite"
          onClick={() => dispatch(showModal(() => <ArchivedAttachmentsModal recordId={recordId} />, {
            actionRequired: false,
            maxWidth: 1040,
            title: 'Archived Documents'
          }))}
        />
      </Flex>
    </Box>
  );
};

AttachmentIconTray.propTypes = { recordId: PropTypes.number.isRequired };

export default AttachmentIconTray;
